import type { Placement } from '@floating-ui/core';
import { FloatingPortal } from '@floating-ui/react';
import React from 'react';
import { useTooltip } from '@/hooks/useTooltip';

type TooltipProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  placement?: Placement;
  isVisible?: boolean;
  strategy?: 'absolute' | 'fixed';
  forcedOpen?: boolean;
  offset?: number;
  className?: string;
  withPortal?: boolean;
};

export const Tooltip = (props: TooltipProps) => {
  const {
    children,
    content,
    placement = 'top',
    isVisible = true,
    forcedOpen,
    offset,
    className,
    withPortal = false,
  } = props;
  const { refs, floatingStyles, open, getReferenceProps, getFloatingProps } = useTooltip({
    placement,
    ...(offset !== undefined ? { offset } : {}),
    ...props,
  });
  const isOpen = forcedOpen ?? open;

  const floating = (
    <div ref={refs.setFloating} style={floatingStyles} className={className} {...getFloatingProps()}>
      {content}
    </div>
  );

  return (
    <>
      <span ref={refs.setReference} {...getReferenceProps()}>
        {children}
      </span>

      {isOpen && isVisible && (withPortal ? <FloatingPortal>{floating}</FloatingPortal> : floating)}
    </>
  );
};
